/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Humanize from 'humanize-plus';

import DeleteAttachment from '@/services/DeleteAttachment';

import showErrorMessage from '../../util/showErrorMessage';

import tmplFileView from './FileView.hbs';

const FileView = View.extend({
  template: tmplFileView,

  className: 'file-view',

  ui: {
    btnDelete: '.delete',
    fileIcon: '.file-icon',
    fileName: '.file-name',
    fileSize: '.file-size',
    download: '.download'
  },

  events: {
    'click .download': 'downloadFile',
    'click @ui.btnDelete': 'onClickDelete'
  },

  modelEvents: {
    'change:uploadFailed': 'handleError',
    'upload:start': 'onUploadStart',
    'upload:complete': 'onUploadComplete'
  },

  initialize() {
    this.model.set('fileSizeReadable', Humanize.fileSize(this.model.get('fileSize')));
    this.attachmentId = this.model.get('attachmentId');
  },

  onRender() {
    if (!this.model.get('isReadOnly') && !this.model.get('isPreloaded')) {
      this.model.upload();
      this.$('.file-icon').show();
      this.$('.progress').show();
      this.$('.file-name').show();
      this.$('.delete').show();
    } else if (!this.model.get('isReadOnly')) {
      this.$('.delete').show();
      this.$('.download').show();
    } else {
      this.$('.download').show();
      this.$('.delete').hide();
    }
    if (!this.model.get('fileSize')) {
      this.$('.file-size').hide();
    }
    if (this.model.get('hideFileIcon')) {
      this.$('.file-icon').hide();
      this.$('.delete').hide();
    }
  },

  downloadFile(e) {
    e.preventDefault();
    this.model.download(this.$('.file-download-form'));
  },

  onUploadStart() {
    this.ui.btnDelete.attr('disabled', true);
  },

  onUploadComplete(attachmentId) {
    this.attachmentId = attachmentId;
    this.ui.btnDelete?.removeAttr('disabled');
  },

  async onClickDelete(e) {
    e.preventDefault();
    // this.model.cancel();

    this.ui.btnDelete.attr('disabled', true);
    this.model.trigger('file:delete:start', this.attachmentId);

    if (!this.attachmentId) return;

    try {
      await DeleteAttachment(this.attachmentId);
      this.attachmentId = null;
      this.model.trigger('file:delete:end');
      this.model.destroy();
    } catch (e) {
      this.ui.btnDelete?.removeAttr('disabled');
      this.model.trigger('file:delete:error');
      this.showDeleteError();
    }
  },

  handleError(jqXHR, textStatus, errorThrown, erroredFile) {
    // add code if showError is true
    if (this.model.get('showError')) {
      // check that the current upload has error
      if (this.model.get('uploadFailed')) {
        this.$('.file-view').addClass('failed');
      }
    }
  },

  showDeleteError() {
    showErrorMessage({
      errorCode: 'uploadError',
      errorTitle: 'Upload Error',
      errorMessage: 'An error occurred while deleting this file. Please try again or contact an administrator.'
    });
  }
});

export default FileView;
